import createTableStore from "ds/components/Table/store/useTableStore";

import { CONTEXTS_COLUMN_CONFIG, CONTEXTS_COLUMNS_STORAGE_KEY } from "./constants";

const useContextsTableStore = createTableStore({
  storageKey: CONTEXTS_COLUMNS_STORAGE_KEY,
  config: CONTEXTS_COLUMN_CONFIG,
});

export default useContextsTableStore;
